import { render, staticRenderFns } from "./TaskTransformExpressionCard.vue?vue&type=template&id=0039fcb2&scoped=true&"
import script from "./TaskTransformExpressionCard.vue?vue&type=script&lang=ts&"
export * from "./TaskTransformExpressionCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTransformExpressionCard.vue?vue&type=style&index=0&id=0039fcb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039fcb2",
  null
  
)

export default component.exports